export default __webpack_public_path__ + "static/media/team-3.0ef0be95.jpg";